import React, { useState } from "react";
import styles from "./PasswordInput.module.css";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { Tooltip } from "@mui/material";

type props = {
  title: string;
  children?: any;
  validator?: (value: string) => string;
  onPress?: () => void;
  tooltiptext?: any;
};

const PasswordInputWithTooltip = React.forwardRef(
  ({ title, children, validator, onPress, tooltiptext }: props, ref: any) => {
    const [show, setShow] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [tooltipOpen, setTooltipOpen] = useState(false);
    return (
      <>
        <div className={styles.input}>
          {children}
          <Tooltip title={tooltiptext} arrow open={tooltipOpen}>
            <input
              id={styles.inputText}
              type={show ? "text" : "password"}
              name="name"
              placeholder={title}
              ref={ref}
              onBlur={() => {
                setTooltipOpen(false);
                if (validator) {
                  setErrorMsg(validator(ref.current.value));
                }
              }}
              onKeyDown={(e) => {
                if (onPress) {
                  if (e.code === "Enter") {
                    onPress();
                  }
                }
              }}
              onFocus={() => {
                setTooltipOpen(true);
              }}
              autoComplete="off"
            />
          </Tooltip>
          <div className={styles.try}>
            {show ? (
              <BsEyeFill
                color={"#808080"}
                size={"16"}
                onClick={() => setShow(!show)}
              />
            ) : (
              <BsEyeSlashFill
                color={"#808080"}
                size={"16"}
                onClick={() => setShow(!show)}
              />
            )}
          </div>
        </div>
        {errorMsg.length !== 0 && <p className={styles.error}>{errorMsg}</p>}
      </>
    );
  }
);

export default PasswordInputWithTooltip;
